import { FC } from "react";
import "./board.css";
import blackboardBg from "./assets/blackboard-bg.webp";
import whiteboardBg from "./assets/whiteboard-bg.webp";
import { TemplateBackgroundProps, TemplateLabelTitleProps, TemplateScheduleTableProps } from "./types";

// 背景画像に表組み・見出し・曜日ラベルまで焼き込まれているため、
// このテンプレートは「セルへ文字を流し込むオーバーレイ」として実装する。
// 座標はすべて 1200x675 のプレビュー座標系に合わせた実測値（board.css 参照）。
export type BoardThemeId = "board-blackboard" | "board-whiteboard";

const BOARD_BACKGROUNDS: Record<BoardThemeId, string> = {
  "board-blackboard": blackboardBg,
  "board-whiteboard": whiteboardBg,
};

const isBoardThemeId = (themeId: string): themeId is BoardThemeId => themeId in BOARD_BACKGROUNDS;

const resolveBoardBackground = (themeId: string) =>
  isBoardThemeId(themeId) ? BOARD_BACKGROUNDS[themeId] : blackboardBg;

export const BoardTemplateBackgroundDecoration: FC<TemplateBackgroundProps> = ({ theme }) => (
  <img className="boardBg" src={resolveBoardBackground(theme.id)} alt="" />
);

export const BoardTemplateLabelTitle: FC<TemplateLabelTitleProps> = ({ periodStartLabel }) => {
  // 背景画像のタイトルが「（余白）月週間行事予定表」なので、開始月の数字だけを余白へ重ねる。
  const [month] = periodStartLabel.split("/");

  return <span className="titleMonth">{month}</span>;
};

export const BoardTemplateScheduleTable: FC<TemplateScheduleTableProps> = ({ items }) => (
  <div className="parts scheduleTable">
    {items.map((item) => (
      <div className={`item ${item.isOff ? "is-off" : ""}`.trim()} key={item.key}>
        <span className="day">{item.dayNumber}</span>
        {/* 曜日は背景画像に焼き込み済み。列幅を確保するためだけの空要素 */}
        <span className="week" aria-hidden="true" />
        <span className="body">
          {item.time && <span className="time">{item.time}</span>}
          <span className="content">{item.content}</span>
        </span>
      </div>
    ))}
  </div>
);
